var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisaCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11831",
    "data-name": "Group 11831",
    transform: "translate(-85.318 -987.234)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37711",
    "data-name": "Path 37711",
    d: "M175.483,180.928l.941-5.555h1.523l-.941,5.555Z",
    transform: "translate(-80.146 820.056)",
    fill: "#293688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37712",
    "data-name": "Path 37712",
    d: "M225.812,173.88a3.955,3.955,0,0,0-1.365-.233c-1.505,0-2.565.754-2.575,1.833-.008.8.757,1.243,1.335,1.509s.792.446.789.689c0,.372-.474.543-.912.543a3.214,3.214,0,0,1-1.434-.292l-.2-.089-.214,1.244a4.844,4.844,0,0,0,1.7.3c1.6,0,2.641-.745,2.652-1.9.006-.632-.4-1.113-1.279-1.509-.532-.257-.859-.428-.855-.689,0-.231.276-.478.872-.478a2.824,2.824,0,0,1,1.14.213l.136.064.207-1.2Z",
    transform: "translate(-123.53 820.691)",
    fill: "#293688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37713",
    "data-name": "Path 37713",
    d: "M303.735,175.373a.757.757,0,0,0-.789.473l-2.257,5.082H302.3l.314-.851h1.927l.179.851h1.434l-1.254-5.555h-1.165Zm-.692,3.592c.126-.32.607-1.553.607-1.553s.125-.321.2-.53l.1.479.353,1.6h-1.264Z",
    transform: "translate(-198.856 819.056)",
    fill: "#293688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37714",
    "data-name": "Path 37714",
    d: "M80.98,179.181l-.134-.762a4.339,4.339,0,0,0-2.107-2.329l1.346,4.838H81.7l2.419-5.555H82.5Z",
    transform: "translate(11.579 820.056)",
    fill: "#293688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37715",
    "data-name": "Path 37715",
    d: "M46.823,175.373v.09a5.2,5.2,0,0,1,3.763,2.957l-.552-2.572a.655.655,0,0,0-.7-.474Z",
    transform: "translate(41.637 820.056)",
    fill: "#f7981d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37716",
    "data-name": "Path 37716",
    d: "M48.513,346.233H26.7C28.745,350.169,46.463,350.169,48.513,346.233Z",
    transform: "translate(58.72 657.06)",
    fill: "#f7981d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3816",
    "data-name": "Rectangle 3816",
    width: 26,
    height: 5,
    transform: "translate(85.318 987.234)",
    fill: "#293688"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3817",
    "data-name": "Rectangle 3817",
    width: 26,
    height: 5,
    transform: "translate(85.318 1003.234)",
    fill: "#f7981d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaCard);
export default __webpack_public_path__ + "static/media/Visa-Card.399839db.svg";
export { ForwardRef as ReactComponent };